// Import model
import { FilterObjectTypeRequest } from '../models/FilterObjectTypeRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ObjectTypeCondition } from '../models/ObjectTypeCondition';
import { ObjectTypeFields } from '../models/ObjectTypeFields';
import { ObjectTypeIndexedFields } from '../models/ObjectTypeIndexedFields';

// Import dependency serializers (for complex types)
import { ObjectTypeConditionSerializer } from './ObjectTypeConditionSerializer';
import { ObjectTypeFieldsSerializer } from './ObjectTypeFieldsSerializer';
import { ObjectTypeIndexedFieldsSerializer } from './ObjectTypeIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterObjectTypeRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterObjectTypeRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterObjectTypeRequest instance
   */
  static deserialize(json: string): FilterObjectTypeRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterObjectTypeRequest instance
   */
  static fromObject(obj: any): FilterObjectTypeRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterObjectTypeRequest');
    }


    const instance: FilterObjectTypeRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as ObjectTypeIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as ObjectTypeFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        ObjectTypeConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterObjectTypeRequest instances
   */
  static deserializeArray(json: string): FilterObjectTypeRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterObjectTypeRequest instance to a JSON string
   */
  static serialize(instance: FilterObjectTypeRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterObjectTypeRequest instance to a plain object
   */
  static toObject(instance: FilterObjectTypeRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        ObjectTypeConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterObjectTypeRequest instances to a JSON string
   */
  static serializeArray(instances: FilterObjectTypeRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
